import { getAddress } from 'viem'

/**
 * Our own image of each CADINU Identity Arts collection (public/images/nfts; same list as views/ProfileCreation/helper and
 * the API's getNftThumbnail). Used when the NFT metadata API fails (2026-10-03: IPFS gateway 429 -> api/nft 500). Unlike
 * getNftImage (which answers "hunter" for any unknown address), an unknown collection gives null.
 */
const IMAGES: Record<string, string> = {
  // level 1
  '0xbe548336c849aa2B7415A62702c5F3D5f64D9F7e': 'level1/cadinu_nft_artist_250.png',
  '0xcB6165e1fFA6426B5bB596ec806Cae3c356ad366': 'level1/cadinu_nft_business_250.png',
  '0xC0Dda5d8706ccE72487438Ea4Af5dc03Ef6B12a2': 'level1/cadinu_nft_cowboy_250.png',
  '0xc24397e0766CC7E52Ce0D281bef590e644226312': 'level1/cadinu_nft_loyalty_250.png',
  '0xeFe7b3853e05C6f39f2c57fe4566cb0A6bc640Cd': 'level1/cadinu_nft_futuristic_250.png',
  '0x933834fe626BDD84A4F7a4Db96132a1029a80fbd': 'level1/cadinu_nft_hunter_250.png',
  // level 2
  '0x1E10dFcc623c44891c88C1ec4D54C9bCb0ffB78c': 'level2/cadinu_nft_artist_250.png',
  '0x1f8ABe5f9C4a30da159F0Bae4d1ACbbfa02E60E8': 'level2/cadinu_nft_business_250.png',
  '0xaa27345f2c310394D96580A9AaBCEcf5CA19350a': 'level2/cadinu_nft_cowboy_250.png',
  '0x2523918D98518E324834Fad150077Dff3331C9c7': 'level2/cadinu_nft_loyalty_250.png',
  '0x67bFFaDA0EAE97ed78b5ad1Ed763f2613cDC857D': 'level2/cadinu_nft_futuristic_250.png',
  '0xd725793b8a42607600d14075e1945E59D8C30E34': 'level2/cadinu_nft_hunter_250.png',
}

/** Absolute path of our image for a collection, or null for any other collection / bad input. */
export const localNftImage = (collection?: string | null): string | null => {
  try {
    const p = collection ? IMAGES[getAddress(collection)] : undefined
    return p ? `/images/nfts/${p}` : null
  } catch {
    return null
  }
}
